<template>
<div id="client-reviews" class="container mt-5">
    <div class="row justify-content-center text-center">
        <div class="col-md-12 col-sm-12">
            <h2 class="hk-headline bg-slider m-0">Here’s What Our Clients Have To Say About Us</h2>
        </div>

    </div>
    <div id="reviewsCarousel" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-inner ">

            <div v-for="(item, index) in carouselItems" :key="index" class="carousel-item" :class="{ active: index === 0 }">
                <div class="row justify-content-center text-center my-auto">

                    <div class="col-md-8" style="display: flex; justify-content: center; align-items: center; flex-direction: column;">
                        <!-- <h5 class="fw-bold">{{ item.name }}</h5> -->
                        <p class="text-muted">{{ item.profile }}</p>
                        <p class="hk-subbody">"{{ item.description }}"</p>
                    </div>
                </div>
            </div>

        </div>
       <button class="carousel-control-prev" type="button" data-bs-target="#reviewsCarousel" data-bs-slide="prev">
    <img src="@/assets/common/arrow-left-32.svg" alt="Previous" class="custom-carousel-icon">
    <span class="visually-hidden">Previous</span>
</button>

<button class="carousel-control-next" type="button" data-bs-target="#reviewsCarousel" data-bs-slide="next">
    <img src="@/assets/common/arrow-right-32.svg" alt="Next" class="custom-carousel-icon">
    <span class="visually-hidden">Next</span>
</button>

    </div>
</div>
</template>

<script>
export default {
    name: "ClientReviews",
    data() {
        return {
            carouselItems: [{
                    name: "Rob Palleschi",
                    profile: "Former CEO, G6",
                    description: "People do business with trusted partners and solid companies. HotelKey, our technology partner, has brought a robust product to our company and franchisees. HotelKey has made my life much easier. I can view my entire portfolio KPI data and reports on my smartphone real-time anywhere and anytime of the day.",
                },
                {
                    name: "Jessie Burgess",
                    profile: "Former CIO, G6",
                    description: "At G6 Hospitality, we strive to provide our guests with convenient quality service from the moment they arrive, and that means having a reliable and easy-to-use property management system in place. HotelKey creates the flexibility for Motel 6 and Studio 6 franchisees to effectively manage their property from any device, helping to streamline their operations across the board and most importantly, enhancing the guest experience.",
                },
                {
                    name: "Kevin Dailey",
                    profile: "Chief Operating Officer, LivAway Suites",
                    description: "We chose HotelKey because they are highly adaptive, brilliant programmers who have carved out a unique niche in the extended-stay arena. HotelKeys efficient and flexible technology will allow us to maintain our lean operating model while elevating LivAways guest experience versus the competition.",
                },
                {
                    name: "George Limbert",
                    profile: "Red Roof President",
                    description: "The impact of this state-of-the-art system for both our franchisees and guests underscores our commitment to delivering the best experience and value in the lodging industry. HotelKey’s technology builds upon our legacy programs providing the most effective solutions to help franchisees streamline operations and ultimately benefit our guests.",
                },
            ],
        };
    },
};
</script>

<style scoped>


.carousel-item {
    padding: 20px;
    background-color: #f8f9fa;
    border-radius: 0px 0px 10px 10px;
    height: 200px;
    /* Set constant height */
    overflow-y: auto;
    /* Allow scrolling if content exceeds height */
}

.bg-slider {
    background-color: #f8f9fa;
    border-radius: 10px 10px 0px 0px;
    padding: 25px 20px 10px;
}

.description {
    word-wrap: break-word;
    max-height: 150px;
    /* Optional: Limit height for descriptions */
    overflow-y: auto;
    /* Add a scrollbar for overflowing text */
}

@media (max-width: 575.98px) {
    .carousel-item {
        padding: 20px;
        background-color: #f8f9fa;
        border-radius: 0px 0px 10px 10px;
        height: 350px;
        align-items: center;
        justify-content: center;
        /* Set constant height */
        overflow-y: auto;
        /* Allow scrolling if content exceeds height */
    }
}

.carousel-control-next,
.carousel-control-prev {
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 5%;
    padding: 0;
    color: #fff;
    text-align: center;
    background: 0 0;
    border: 0;
    opacity: .5;
    transition: opacity .15s ease;
}
</style>
